import { atlas } from 'graphql/tags'

export const NOTE_VARIANTS = atlas`#graphql
  mutation noteVariantsDupe1($input: AddVariantsInProgressInput!) {
    addVariantsInProgress(input: $input) {
      orderIds
    }
  }
`

atlas`#graphql
  mutation CreateOrphanRetailer(
    $accountId: ID!
    $retailerName: String!
    $retailerEmail: String!
    $connectionProcessed: Boolean!
  ) {
    createOrphanRetailer(
      input: {
        accountId: $accountId
        retailerName: $retailerName
        retailerEmail: $retailerEmail
        connectionProcessed: $connectionProcessed
      }
    ) {
      id
      retailerName
      retailerEmail
      retailerCode
      connectionProcessed
      update
      created
      deleted
    }
  }
`
